module.exports = __webpack_public_path__ + "img/pinnedPost.90afda24.png";